import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3 cursor-pointer" onClick={() => scrollToSection('home')}>
            <img 
              src="https://public.readdy.ai/ai/img_res/485820f9-1974-4473-a77e-7fbbe90519ce.png" 
              alt="J C CABRAL S.R.L." 
              className="h-10 w-auto"
            />
            <span className={`text-xl font-semibold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
              J C CABRAL
            </span>
          </div>

          <div className="flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('about')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              About
            </button>
            <button
              onClick={() => scrollToSection('features')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Features
            </button>
            <button
              onClick={() => scrollToSection('how-it-works')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('security')}
              className={`text-sm font-medium transition-colors hover:text-teal-500 whitespace-nowrap ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Security
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`px-6 py-2 bg-teal-500 text-white rounded-full text-sm font-medium hover:bg-teal-600 transition-colors whitespace-nowrap ${
                isScrolled ? '' : 'shadow-lg'
              }`}
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
